import script from "./userNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./userNotifications.vue?vue&type=script&setup=true&lang=js"

import "./userNotifications.vue?vue&type=style&index=0&id=8b62f60a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b62f60a"]])

export default __exports__